<template>
  <div
    class="modal fade show modal-dialog-centered modal-dialog-scrollable"
    style="padding-right: 12px; display: block;">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="isAdd" class="modal-title">
            Добавление нового анализа.
          </h5>
          <h5 v-else class="modal-title">
            Редактирование анализа "{{ test.name }}".
          </h5>

          <button type="button" class="close" @click="$emit('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <form class="container">
            <div class="form-group">
              <label>Название</label>
              <input
                type="text"
                :class="'form-control' + (nameError !== '' ? ' is-invalid' : '')"
                v-model="name"/>
            </div>

            <div class="form-group">
              <label>Категория</label>
              <select
                :class="'form-control' + (categoryIdError !== '' ? ' is-invalid' : '')"
                v-model="categoryId">
                <option :value="null">-</option>
                <option
                  v-for="(category, categoryKey) in categories"
                  :key="categoryKey"
                  :value="category.id">{{ category.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Элемент здоровья</label>
              <select
                :class="'form-control' + (healthIdError !== '' ? ' is-invalid' : '')"
                v-model="healthId">
                <option :value="null">-</option>
                <option
                  v-for="(healthElement, healthElementKey) in healthElements"
                  :key="healthElementKey"
                  :value="healthElement.id">{{ healthElement.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>Единицы измерения</label>
              <input
                type="text"
                :class="'form-control' + (measureError !== '' ? ' is-invalid' : '')"
                v-model="measure"/>
            </div>

            <div class="form-group">
              <label>Референсные значения</label>
            </div>

            <div class="form-group row">
              <label for="normal" class="col-sm-4 col-form-label">Норма</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="normal" v-model="normal">
              </div>
            </div>

            <div class="form-group row">
              <label for="standard" class="col-sm-4 col-form-label">Стандарт</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="standard" v-model="standard">
              </div>
            </div>

            <div class="form-group row">
              <label for="deviation" class="col-sm-4 col-form-label">Отклонение</label>
              <div class="col-sm-8">
                <input type="text" class="form-control" id="deviation" v-model="deviation">
              </div>
            </div>

            <div class="form-group">
              <label>Описание</label>
              <textarea
                :class="'form-control' + (descriptionError !== '' ? ' is-invalid' : '')"
                v-model="description"></textarea>
            </div>
          </form>
        </div>

        <div class="modal-footer justify-content-between">
          <button v-if="!isAdd" type="button" class="btn btn-danger" @click="deleteTest">
            Удалить
          </button>
          <button type="button" class="btn btn-primary float-right" @click="submitTest">
            {{ isAdd ? 'Добавить' : 'Обновить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestForm',

  props: ['test', 'categories', 'healthElements'],

  data() {
    return {
      isAdd: '',
      name: '',
      categoryId: '',
      healthId: '',
      measure: '',
      normal: '',
      standard: '',
      deviation: '',
      nameError: '',
      description: '',
      measureError: '',
      descriptionError: '',
      categoryIdError: '',
      healthIdError: '',
    };
  },

  created() {
    this.isAdd = typeof this.test === 'undefined';
    this.name = this.isAdd ? '' : this.test.name;
    this.measure = this.isAdd ? '' : this.test.measure;
    this.description = this.isAdd ? '' : this.test.description;
    this.categoryId = this.isAdd ? null : this.test.categoryId;
    this.healthId = this.isAdd ? null : this.test.healthId;
    this.normal = this.isAdd ? '' : this.test.reference.normal;
    this.standard = this.isAdd ? '' : this.test.reference.standard;
    this.deviation = this.isAdd ? '' : this.test.reference.deviation;
  },

  methods: {
    submitTest() {
      const data = {
        name: this.name,
        measure: this.measure,
        description: this.description,
        categoryId: this.categoryId,
        healthId: this.healthId,
        reference: {
          normal: this.normal,
          standard: this.standard,
          deviation: this.deviation,
        },
      };

      if (typeof this.name !== 'string' || this.name.trim() === '') {
        this.nameError = 'Неверно указано имя';

        return;
      }

      if (typeof this.measure !== 'string') {
        this.measureError = 'Неверно указано единица измерения';

        return;
      }

      if (typeof this.description !== 'string') {
        this.descriptionError = 'Неверно указано описание';

        return;
      }

      if (this.isAdd) {
        this.$emit('create-test', data);
      } else {
        this.$emit('update-test', Object.assign({id: this.test.id}, data));
      }
    },

    deleteTest() {
      this.$emit('delete-test', this.test.id);
    },
  },
};
</script>
